import { create } from 'zustand'

import reducer, { initialState } from './reducer'
import { Action, HomeAction, HomeState } from './types'

export const useHomeStore = create<HomeState & Action>()((set) => ({
  ...initialState,
  dispatch: (action: HomeAction) => set((state) => reducer(state, action))
}))
